
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19.2","height":"16","data-name":"グループ 561"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#12b6d4","d":"M9.6 16a.8.8 0 01-.8-.8v-2H6.6A6.6 6.6 0 016.6 0h6a6.613 6.613 0 016.6 6.541V6.6a6.606 6.606 0 01-6.412 6.6l-2.627 2.577A.8.8 0 019.6 16m-3-14.4a4.995 4.995 0 000 9.989h3a.8.8 0 01.8.8v.894l1.5-1.461a.8.8 0 01.562-.23h.138a5 5 0 005-4.992v-.028a5.005 5.005 0 00-5-4.972z","data-name":"パス 744"}}),_c('path',{attrs:{"fill":"#12b6d4","d":"M5.688 5.589a.978.978 0 10.978.978.978.978 0 00-.978-.978","data-name":"パス 745"}}),_c('path',{attrs:{"fill":"#12b6d4","d":"M9.6 5.589a.978.978 0 10.978.978.978.978 0 00-.978-.978","data-name":"パス 746"}}),_c('path',{attrs:{"fill":"#12b6d4","d":"M13.512 5.589a.978.978 0 10.978.978.978.978 0 00-.978-.978","data-name":"パス 747"}})])
          )
        }
      }
    